import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Import des composants d'authentification
import LoginForm from '../components/auth/LoginForm';
import RegisterForm from '../components/auth/RegisterForm';
import ForgotPasswordForm from '../components/auth/ForgotPasswordForm';
import ResetPasswordForm from '../components/auth/ResetPasswordForm';

/**
 * Page d'authentification qui gère les différents modes:
 * - login: connexion
 * - register: inscription
 * - forgotPassword: mot de passe oublié
 * - resetPassword: réinitialisation du mot de passe
 */
const AuthPage = () => {
  const { t } = useTranslation();
  const { mode } = useParams(); // récupère le mode depuis l'URL /auth/:mode
  const { user, loading } = useAuth();
  const location = useLocation();
  const [currentMode, setCurrentMode] = useState(mode || 'login');

  // Récupération de l'URL de redirection après connexion
  const from = location.state?.from?.pathname || '/';

  // Mise à jour du mode si l'URL change
  useEffect(() => {
    if (mode && ['login', 'register', 'forgotPassword', 'resetPassword'].includes(mode)) {
      setCurrentMode(mode);
    } else {
      // Mode par défaut ou invalide
      setCurrentMode('login');
    }
  }, [mode]);

  // Si l'utilisateur est connecté, rediriger vers la page d'origine
  // sauf pour le mode resetPassword qui peut être utilisé même connecté
  if (user && currentMode !== 'resetPassword') {
    return <Navigate to={from} replace />;
  }

  // Fonction pour changer de mode (login, register, etc.)
  const handleModeChange = (newMode) => {
    setCurrentMode(newMode);
  };

  // Affichage du bon formulaire selon le mode
  const renderAuthForm = () => {
    switch (currentMode) {
      case 'register':
        return <RegisterForm onModeChange={handleModeChange} />;
      case 'forgotPassword':
        return <ForgotPasswordForm onModeChange={handleModeChange} />;
      case 'resetPassword':
        return <ResetPasswordForm />;
      case 'login':
      default:
        return <LoginForm onModeChange={handleModeChange} />;
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-gray-50">
      {/* <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          className="mx-auto h-12 w-auto"
          src="/logo.svg" 
          alt="Maploop Logo"
        />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          {t('app.name')}
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          {t('app.slogan')}
        </p>
      </div> */}

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          </div>
        ) : (
          renderAuthForm()
        )}
      </div>
    </div>
  );
};

export default AuthPage;
